import { render, staticRenderFns } from "./CreditClassTeacher.vue?vue&type=template&id=3c5fb66d&"
import script from "./CreditClassTeacher.vue?vue&type=script&lang=js&"
export * from "./CreditClassTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports